<template>
    <validation-observer v-slot="{ meta, setFieldValue }">
        <modal
            :ok-disabled="!meta.valid"
            :id="modalId"
            @ok="onSave"
            @hide="$emit('hide')"
            :title="isView ? 'View Caption' : 'Edit Caption'"
            :ok-title="isView ? 'OK' : 'Save'"
            :ok-only="isView"
            @shown="setFieldValue('caption', initialCaption)"
        >
            <span v-if="isView">{{ initialCaption }}</span>
            <validation-provider name="caption" v-else v-slot="{ errors, handleChange }" rules="maxMessageLen:251,Caption" >
                <form-input label="Caption:" v-model="initialCaption" :error="errors[0]" @input="handleChange" />
            </validation-provider>
        </modal>
    </validation-observer>
</template>

<script>
import Modal from '../generic/modal/modal.vue';
import FormInput from '../generic/form-input/form-input.vue';
export default {
    name: 'PhotoCaptionModal',
    components: {
        Modal,
        FormInput,
    },
    props: {
        modalId: String,
        id: Number,
        caption: String,
        isView: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            initialCaption: this.caption,
        };
    },
    methods: {
        onSave() {
            if (!this.isView) {
                this.$emit('save', { id: this.id, caption: this.initialCaption });
            }
        },
    },
    watch: {
        caption() {
            this.initialCaption = this.caption;
        },
    },
};
</script>
